<div class="about-wrapper">
  <div class="about-header">
    <div class="brand-logo">
      <img src="/images/logo.png" alt="VETA Investment Partners Logo" />
    </div>

    <div class="brand-info">
      <h3>{{ aboutData.appName }}</h3>
      <span class="version-badge">Version {{ aboutData.version }}</span>
    </div>
  </div>

  <nz-list class="about-list">
    <nz-list-item>
      <div class="about-item">
        <span class="about-label">
          <nz-icon nzType="cloud-server" nzTheme="outline" />
          Environment
        </span>

        <span
          class="about-value environment"
          [class.production]="aboutData.production"
        >
          {{ aboutData.environment }}
        </span>
      </div>
    </nz-list-item>
    <nz-list-item>
      <div class="about-item">
        <span class="about-label">
          <nz-icon nzType="global" nzTheme="outline" />
          Base URL
        </span>

        <span class="about-value url">
          {{ aboutData.apiBaseUrl }}
        </span>
      </div>
    </nz-list-item>

    <nz-list-item>
      <div class="about-item">
        <span class="about-label">
          <nz-icon nzType="safety-certificate" nzTheme="outline" />
          Auth URL
        </span>

        <span class="about-value url">
          {{ aboutData.authUrl }}
        </span>
      </div>
    </nz-list-item>

    <nz-list-item>
      <div class="about-item">
        <span class="about-label">
          <nz-icon nzType="safety-certificate" nzTheme="outline" />
          Mode
        </span>

        <span
          class="status-badge"
          [class.is-production]="aboutData.production"
          [class.is-development]="!aboutData.production"
        >
          <span class="status-dot"></span>
          {{ aboutData.production ? 'Production' : 'Development' }}
        </span>
      </div>
    </nz-list-item>
  </nz-list>

  <div class="about-footer">
    <span>© {{ currentYear }} {{ aboutData.appName }}</span>
  </div>
</div>





